import { FileBarChart2, FileClock, FilePieChart, Plus } from 'lucide-react';
import { Badge, Button, Card } from '@fintracks/ui';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../components/States';
import { appMode } from '../data/repository';

const templates = [
  { icon: FilePieChart, title: 'Plano consolidado', text: 'Diagnóstico, objetivos e recomendações em uma narrativa única.', tag: 'Completo' },
  { icon: FileBarChart2, title: 'Cenário de aposentadoria', text: 'Premissas, estratégias comparadas e evolução patrimonial.', tag: 'Analítico' },
  { icon: FileClock, title: 'Relatório de acompanhamento', text: 'Progresso, desvios e decisões desde a última revisão.', tag: 'Recorrente' },
];

export default function Reports() {
  const navigate = useNavigate();
  const openReport = () => navigate('/clientes');
  return <div className="page">
    <PageHeader eyebrow="Documentos" title="Relatórios" description="Transforme análises em conversas claras e rastreáveis." actions={<Button variant="primary" onClick={openReport}><Plus size={16} /> Novo relatório</Button>} />
    <div className="report-grid">{templates.map(({ icon: Icon, title, text, tag }) => <Card className="report-card" key={title}><span className="report-card__icon"><Icon size={20} /></span><h2>{title}</h2><p>{text}</p><footer><Badge tone="info">{tag}</Badge><Button variant="ghost" onClick={openReport}>Preparar</Button></footer></Card>)}</div>
    <div className="section-head" style={{ marginTop: 32 }}><div><h2>Relatório por cliente</h2><p>{appMode === 'demo' ? 'Versões locais salvas na ficha do cliente' : 'Snapshots canônicos salvos na ficha do cliente'}</p></div></div>
    <div className="client-list">
      <Card className="empty-state"><FileClock /><h3>Escolha um cliente</h3><p>O histórico e a emissão do relatório 360 ficam vinculados à ficha, ao cenário e às fontes atuais.</p><Button onClick={openReport}>Abrir clientes</Button></Card>
    </div>
  </div>;
}
